/** @format */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, of } from 'rxjs';
import { switchMap, take, map, first } from 'rxjs/operators';
import { DbService } from './db.service';
import { AlertService } from './alert.service';
import 'firebase/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$: Observable<any>;
  usertmp$: Observable<any>;
  currentUid;
  constructor(public afAuth: AngularFireAuth, public db: DbService, public router: Router, public alertService: AlertService) {
    this.user$ = this.afAuth.authState.pipe(switchMap(user => (user ? db.doc$(`users/${user.uid}`) : of(null))));

    this.afAuth.authState.subscribe(data => {
      if (data) {
        localStorage.setItem('userId', data.uid);
      }
    });
  }

  // 유저의 uid 반환
  uid() {
    return this.afAuth.authState
      .pipe(
        take(1),
        map(u => u && u.uid)
      )
      .toPromise();
  }

  //로그인 로그아웃
  loginUser(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase.default
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          res => resolve(res),
          err => reject(err)
        )
        .catch(err => reject(err));
      // this.redirect();
    });
  }

  logoutUser() {
    return new Promise((resolve, reject) => {
      if (firebase.default.auth().currentUser) {
        firebase.default
          .auth()
          .signOut()
          .then(res => {
            localStorage.clear();
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  }
}
